import React from 'react';
import {Switch} from 'react-router-dom';

// Route Setting
import HomePage from "../HomePage";
import OurPaystubs from "../OurPaystubs";
import Guide from "../Guide";

// Normal Route
import PrivateRoute from "../_PrivateRoute";
import Pricing from "../Pricing";
import PrivacyPolicy from "../Privacy Policy";
import ContactUsPage from "../ContactUsPage";
import FaqPage from '../FaqPage';
import TermsOfService from '../TermsOfService';

export default function Routes() {
        return (
            <Switch>
                    <PrivateRoute
                        fixHeader={true}
                        exact
                        path="/"
                        component={HomePage}
                    />
                    <PrivateRoute
                        path="/our-paystubs"
                        component={OurPaystubs}
                    />
                    <PrivateRoute
                        path="/guide"
                        component={Guide}
                    />
                    <PrivateRoute
                        path="/pricing"
                        component={Pricing}
                    />
                    <PrivateRoute
                        path="/faq"
                        component={FaqPage}
                    />
                    <PrivateRoute
                        path="/privacy-policy"
                        component={PrivacyPolicy}
                    />
                    <PrivateRoute
                        path="/terms-of-service"
                        component={TermsOfService}
                    />

                    <PrivateRoute
                        path="/contact-us"
                        component={ContactUsPage}
                    />

                    <PrivateRoute
                        exact
                        component={HomePage}
                    />
            </Switch>
        );
}
